export const SUBMISSION_FAILED = 'SUBMISSION_FAILED'
export const SUBMISSION_STARTED = 'SUBMISSION_STARTED'
export const SUBMISSION_SUCCEEDED = 'SUBMISSION_SUCCEEDED'
